import React from 'react';
import { Link } from 'react-router-dom';

import Seo from '../components/SEO/Seo';
import './NotFound.scss';

const NotFound = () => (
  <div className="not-found-container">
    <Seo
      title="404 Page Not Found"
      description="The page you are looking for does not exist. Return to DantSri Dental Clinic for trusted dental care and appointment booking."
      noindex
    />

    <div className="not-found-content">
      <h1>404</h1>
      <h2>Oops! Page Not Found</h2>
      <p>We can't seem to find the page you're looking for.</p>
      <Link to="/" className="home-link">🏠 Back to Home</Link>
    </div>
  </div>
);

export default NotFound;
